/**
 * BODi Auth Link Redirect URL Handler
 *
 * Adds redirectUrl parameter to all BODi auth links:
 * - Login: redirects to Shopify customer authentication page with return path
 * - Logout: redirects to Shopify Customer Accounts logout page
 */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bodi-auth-link]').forEach(function (link) {
      try {
        const url = new URL(link.href);
        const isLogout = url.pathname.includes('/logout');

        if (isLogout) {
          link.addEventListener('click', function () {
            try {
              localStorage.removeItem('bodi-shop-signed-in');
            } catch (error) {
              // Ignore storage failures; BODi logout still proceeds.
            }
          });

          const redirectUrl = window.BODi?.configs?.accountLogoutUrl;

          if (!redirectUrl) {
            console.warn('Missing accountLogoutUrl config for BODi logout redirect');
            return;
          }

          url.searchParams.set('redirectUrl', redirectUrl);
        } else {
          // For login, redirect to Shopify customer authentication page with return path
          const returnPath = window.location.pathname + window.location.search;
          const loginUrl = new URL('/customer_authentication/login', window.location.origin);
          loginUrl.searchParams.set('return_to', returnPath);
          url.searchParams.set('redirectUrl', loginUrl.toString());
        }

        link.href = url.toString();
      } catch (e) {
        // Silently fail if URL parsing fails
        console.warn('Failed to add redirectUrl to auth link:', e);
      }
    });
  });
})();
